import Api from "../..";
import TransmedRegistrationField from "../../../dtos/transmed/process/registration/field";
import {
  TransmedRegistrationFieldValidationCreateInput,
  TransmedRegistrationFieldValidationInput,
} from "../../../dtos/transmed/process/validation/field";
import transform from "../../../service/transform";

export default class TransmedValidateRegistrationFieldApi extends Api {
  constructor() {
    super("transmed/registration/validate/field");
  }

  public async post(
    data: TransmedRegistrationFieldValidationCreateInput
  ): Promise<TransmedRegistrationField> {
    return await transform(TransmedRegistrationField)(
      (
        await super.post(data)
      ).data
    );
  }

  public async put(
    id: string,
    data: TransmedRegistrationFieldValidationInput
  ): Promise<TransmedRegistrationField> {
    return await transform(TransmedRegistrationField)(
      (
        await super.put(id, data)
      ).data
    );
  }
}
